export function isDismissed(key, ttlMs) {
  if (typeof window === "undefined") return false;

  try {
    const raw = localStorage.getItem(key);
    if (!raw) return false;

    const parsed = JSON.parse(raw);
    if (!parsed?.dismissedAt) return false;

    return Date.now() - parsed.dismissedAt < ttlMs;
  } catch {
    return false;
  }
}

export function setDismissed(key) {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(
      key,
      JSON.stringify({ dismissedAt: Date.now() })
    );
  } catch {
    // Ignore quota / private mode errors
  }
}
